import React, { useEffect } from "react";
import styled from "styled-components";
import { useSnapshot } from "valtio";
import Constaint from "../../../layout/components/Constaint";
import { useSearchParams } from "react-router-dom";
import { useSignin } from "../../../../../hooks/auth/useAuth";
import useLoginRes from "../../../auth/components/useLoginRes";
import { businessFibiClientStore } from "../../../../../store/businessFibiClient";

import useIsLoggedIn from "../../../../../hooks/useIsLoggedIn";
import FiBiAuth from "../components/FiBiAuth";
import { utilsQueryKeys } from "../../../../../hooks/utils/types";
import { useQueryClient } from "@tanstack/react-query";
import {
  saveBusinessVoiceInterviewChatGpt,
  userInitializeInterview,
} from "../../../../../api/ai";
import BusinessFibiVoice from "./components/BusinessFibiVoice";
import { decodeBase64, FibiAiQuery } from "./components/data";
import RequestWrapper from "../../../components/RequestWrapper";

const FiBiVoice = () => {
  const isLoggedIn = useIsLoggedIn();
  const [searchParams] = useSearchParams();
  const eType = searchParams.get("e");
  const pType = searchParams.get("p");
  const bType = searchParams.get("b");
  const fibiUserType = searchParams.get(FibiAiQuery.userType);
  const { mutate } = useSignin();
  const { onLoginSuccess } = useLoginRes();
  const { fibiClientToken } = useSnapshot(businessFibiClientStore);
  const queryClient = useQueryClient();

  useEffect(() => {
    businessFibiClientStore.fibiClientToken = undefined;
    if (fibiUserType) return;

    if (eType && pType && bType) {
      const eTemp = decodeBase64(eType);
      const pTemp = decodeBase64(pType);
      const bTemp = decodeBase64(bType);

      const fetch = async () => {
        try {
          await saveBusinessVoiceInterviewChatGpt({
            id: bTemp,
            payload: {
              prompt: "",
              countDown: "",
            },
            sessionCount: 1,
          });

          queryClient.invalidateQueries([utilsQueryKeys.getUserData]);
        } catch (error) {
          console.error("Error generating response:", error);
        }
      };

      const payload = {
        email: eTemp,
        password: pTemp,
      };

      mutate(payload, {
        onSuccess: async (data) => {
          onLoginSuccess(data);
          businessFibiClientStore.fibiClientToken = bTemp;
          await fetch();
        },
      });
    }
  }, [eType, pType, bType, mutate, onLoginSuccess, queryClient, fibiUserType]);

  useEffect(() => {
    if (fibiUserType) {
      const fetch = async () => {
        try {
          await userInitializeInterview({
            sessionCount: 1,
          });

          queryClient.invalidateQueries([utilsQueryKeys.getUserData]);
        } catch (error) {
          console.error("Error generating response:", error);
        }
      };

      fetch();
    }
  }, [queryClient, fibiUserType]);

  useEffect(() => {
    document.title = `FiBi Voice Interview | Your Personalized Interview Trainer`;

    return () => {
      document.title =
        "SeamlessVisa | The Trusted Partner in Your Immigration Journey";
    };
  }, []);

  return (
    <Wrapper>
      <Constaint>
        <Container>
          <MiniContainer>
            <div className="w-full h-full">
              {!isLoggedIn && (
                <FiBiAuth isFibiClient={!!(eType && pType && bType)} />
              )}

              <RequestWrapper
                isLoading={
                  fibiUserType
                    ? fibiUserType === undefined
                    : fibiClientToken === undefined
                }
                isError={false}
                data={true}
              >
                <>
                  {fibiClientToken && <BusinessFibiVoice />}
                  {fibiUserType && <BusinessFibiVoice />}
                  {/* {fibiClientToken ? <BusinessFibiVoice /> : <NormalFiBiVoice />} */}
                </>
              </RequestWrapper>
              {/* <AiDisclaimer /> */}
            </div>
          </MiniContainer>
        </Container>
      </Constaint>
    </Wrapper>
  );
};

export default FiBiVoice;

const Wrapper = styled.div`
  background-color: #f9fcff;
`;

const Container = styled.div`
  padding: 20px 0;
`;

const MiniContainer = styled.div`
  /* min-height: calc(100vh - 150px); */
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: calc(100vh - 150px);
  /* gap: 24px; */

  overflow: hidden;
  width: 100%;
`;
